"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _map2 = _interopRequireDefault(require("lodash/map"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _Alert = _interopRequireDefault(require("@cimpress/react-components/lib/Alert"));

var _filterErrors = _interopRequireDefault(require("../../helpers/filterErrors"));

var _core = require("@emotion/core");

var ErrorAlertsDisplay = function ErrorAlertsDisplay(_ref) {
  var errors = _ref.errors;
  var filteredErrors = (0, _filterErrors["default"])(errors);
  return (0, _core.jsx)("div", null, (0, _map2["default"])(filteredErrors, function (error, idx) {
    return (0, _core.jsx)(_Alert["default"], {
      key: idx,
      title: error.title,
      message: error.message,
      dismissible: false,
      status: "danger"
    });
  }));
};

ErrorAlertsDisplay.propTypes = {
  errors: _propTypes["default"].arrayOf(_propTypes["default"].object).isRequired
};
var _default = ErrorAlertsDisplay;
exports["default"] = _default;